export interface Category {
  slug: string;
  name: string;
  description: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    slug: 'wanghong-tafang',
    name: '网红塌房',
    description: '网红翻车现场全记录，人设崩塌第一手瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20collapse%20with%20shattered%20social%20media%20icons%2C%20warm%20crimson%20and%20amber%20tones%2C%20abstract%20digital%20debris%2C%20Chinese%20entertainment%20style%2C%20bold%20graphic%20composition%2C%20high%20contrast%2C%20editorial%20design%20with%20clean%20simple%20background%2C%20dark%20gradient%20overlay%2C%20no%20text&width=600&height=600&seq=category-wanghong-tafang&orientation=squarish',
  },
  {
    slug: 'heiliao-baoguang',
    name: '黑料曝光',
    description: '独家黑料深度揭秘，还原娱乐圈真实内幕',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20leaked%20documents%20with%20dramatic%20lighting%2C%20warm%20dark%20amber%20and%20crimson%20tones%2C%20abstract%20composition%20of%20folders%20and%20digital%20data%2C%20Chinese%20tabloid%20aesthetic%2C%20high%20contrast%20dramatic%20shadows%2C%20editorial%20photography%20style%2C%20clean%20simple%20dark%20background%2C%20no%20text&width=600&height=600&seq=category-heiliao-baoguang&orientation=squarish',
  },
  {
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '明星恋情、综艺内幕，最全吃瓜合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20entertainment%20news%20collage%20with%20microphone%20and%20camera%20elements%2C%20warm%20crimson%20and%20gold%20accents%2C%20abstract%20geometric%20composition%2C%20Chinese%20entertainment%20industry%20vibe%2C%20bold%20graphic%20design%2C%20high%20contrast%2C%20editorial%20style%20with%20clean%20simple%20background%2C%20no%20text&width=600&height=600&seq=category-yule-bagua&orientation=squarish',
  },
  {
    slug: 'shipin-chigua',
    name: '视频吃瓜',
    description: '实时吃瓜视频，现场直击娱乐圈大事件',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20video%20play%20button%20with%20abstract%20surveillance%20footage%20aesthetic%2C%20warm%20crimson%20and%20amber%20glow%2C%20digital%20glitch%20effects%2C%20Chinese%20social%20media%20live%20streaming%20theme%2C%20high%20contrast%2C%20editorial%20design%20with%20clean%20simple%20background%2C%20no%20text&width=600&height=600&seq=category-shipin-chigua&orientation=squarish',
  },
  {
    slug: 'zongyi-bagua',
    name: '综艺八卦',
    description: '综艺节目幕后故事，嘉宾真实关系大起底',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20show%20stage%20with%20dramatic%20spotlight%20and%20camera%20equipment%2C%20warm%20amber%20and%20crimson%20tones%2C%20abstract%20entertainment%20set%20design%2C%20Chinese%20variety%20show%20aesthetic%2C%20high%20contrast%20editorial%20style%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=600&seq=category-zongyi-bagua&orientation=squarish',
  },
  {
    slug: 'yingshi-bagua',
    name: '影视八卦',
    description: '影视圈最新动态，片场花絮与明星趣事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20clapperboard%20with%20dramatic%20cinematic%20lighting%2C%20warm%20crimson%20and%20gold%20tones%2C%20abstract%20movie%20set%20elements%2C%20Chinese%20film%20industry%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=600&seq=category-yingshi-bagua&orientation=squarish',
  },
];

export const allCategories = categories;

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};